<template>
  <div class="pv-Loader">
    <div :class="{ 'pv-Loader_Table-fullWidth': hideHeader }" class="pv-Loader_Table">
      <ObjectivesTableLoader
        :columns-count="2"
        :hide-header="hideHeader"
        :row-count
        header-height="56px"
      />
    </div>
    <div v-if="!hideHeader" class="pv-Loader_Timelines">
      <div class="pv-Grid_Head">
        <div v-for="n in columnCount" :key="`head-cell-${n}`" class="pv-Timeline_Head_Cell">
          <SkeletonItem :size="XS" width="64px" />
        </div>
      </div>
      <div class="pv-Grid_Body">
        <div v-for="row in rows" :key="`row-${row.id}`" class="pv-GridRow">
          <div
            v-for="n in columnCount"
            :key="`row-${row.id}-body-cell-${n}`"
            class="pv-GridRow_BodyCell"
          >
            <SkeletonItem :size="XS" width="64px" />
            <SkeletonItem :size="XS" width="36px" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'

import { SKELETON_SIZES } from '@/utils/components-configurations/skeleton-item'
import { PROGRESS_VIEW_DEFAULT_COLUMN_COUNT } from '@/utils/progress-view'

import ObjectivesTableLoader from '@/components/ui/SkeletonLoaders/ObjectivesTableLoader'
import SkeletonItem from '@/components/ui/SkeletonLoaders/SkeletonItem'

defineOptions({
  name: 'ProgressViewLoader'
})

const { MD, XS } = SKELETON_SIZES

const ROWS = [
  {
    id: 0,
    width: '250px',
    height: '28px'
  },
  {
    id: 1,
    width: '370px',
    size: MD
  },
  {
    id: 2,
    width: '113px',
    size: MD
  },
  {
    id: 3,
    width: '200px',
    height: '28px'
  },
  {
    id: 4,
    width: '76px',
    height: '28px'
  },
  {
    id: 5,
    width: '32px',
    height: '28px'
  },
  {
    id: 6,
    width: '193px',
    size: MD
  },
  {
    id: 7,
    width: '113px',
    size: MD
  },
  {
    id: 8,
    width: '311px',
    height: '28px'
  },
  {
    id: 9,
    width: '56px',
    height: '28px'
  },
  {
    id: 10,
    width: '93px',
    size: MD
  },
  {
    id: 11,
    width: '113px',
    height: '28px'
  },
  {
    id: 12,
    width: '103px',
    height: '28px'
  },
  {
    id: 13,
    width: '93px',
    height: '28px'
  },
  {
    id: 14,
    width: '93px',
    height: '28px'
  }
]

defineProps({
  hideHeader: {
    type: Boolean
  },

  rowCount: {
    type: Number,
    default: 15
  },

  columnCount: {
    type: Number,
    default: PROGRESS_VIEW_DEFAULT_COLUMN_COUNT
  }
})

const rows = computed(() => ROWS)
</script>

<style lang="scss" scoped>
.pv-Loader {
  display: flex;
  --otl-body-row-height: 64px;
  --column-width: calc(100% / v-bind(columnCount));
  --column-min-width: 182px;
}

.pv-Loader_Table {
  width: 470px;
  overflow: hidden;

  &-fullWidth {
    width: 100%;
  }
}

.pv-Loader_Timelines {
  width: calc(100vw - 470px - var(--ob-current-app-menu-width));
  overflow: hidden;
}

.pv-Grid_Head {
  height: 56px;
  display: flex;
  align-items: center;
}

.pv-Grid_Body {
  display: grid;
}

.pv-Timeline_Head_Cell {
  min-width: var(--column-min-width);
  width: var(--column-width);
  display: flex;
  justify-content: center;
}

.pv-GridRow_BodyCell {
  min-width: var(--column-min-width);
  width: var(--column-width);
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding-left: 20px;
}

.pv-GridRow {
  height: var(--otl-body-row-height);
  display: flex;
  align-items: center;
  overflow: hidden;
}
</style>
